import { DerivedAvailabilityStatusInternal } from '@commerce-product-webcomponents/sdk';
import {
  FAIcon,
  IconStyle,
  LoaderType,
  Tag,
  TagStyle,
  TagWidth,
  Theme,
  useTranslation,
} from '@nextgen-web-framework/all';
import { FC } from 'react';
import type { ProductCardComponentPropsTypes } from '../Molecules';
import {
  AddToWishlistContainer,
  CardType,
  CustomTag,
  DerivedAvailabilityStatusComponentGroupKey,
  DispositionStockStatus,
  Dispositionlabels,
  ProductCardComponent,
  includesDerivedAvailabilityStockStatus,
} from '../Molecules';
import styles from './FreeProductCard.module.scss';
import type { FreeProductCardPropsTypes } from './types/propsTypes';

export const FreeProductCard = (Component: FC<ProductCardComponentPropsTypes>) => {
  const FreeCardComp = (props: FreeProductCardPropsTypes): JSX.Element => {
    const {
      productId,
      brandName,
      productName,
      link,
      alt,
      productSize,
      dateSubText,
      firstAvailableFutureDate,
      derivedAvailabilityStatus,
      productPrice,
      currency,
      productQuantity,
      strikethroughPrice,
      onChangeClick,
      showDispositionHandler,
      onRemoveProduct,
      showPropertiesCollection,
      isSopBenefit = false,
      showLinkForProductCard = true,
      pointValue = '',
      businessVolume = '',
      prefixText,
      showZeroAsFree = true,
      showPromotionTag = true,
      productData,
      showHeartIcon = false,
      showPromotionBenefitTag = false,
      promotionBenefitTagText = '',
    } = props;
    const t = useTranslation();
    return (
      <div className={`${styles['cpw-free-product-card-hoc']}`} data-testid="cpw-free-product-card-hoc-test-id">
        <div className={styles['tag-container']}>
          {showPromotionTag && (
            <>
              {isSopBenefit ? (
                <div className={styles['sop-tag-container']} data-testid="promotion-applied-sop-container-test-id">
                  <Tag
                    className={styles['promotion-tag']}
                    icon={{
                      iconName: 'gift',
                      iconStyle: IconStyle.REGULAR,
                    }}
                    style={TagStyle.SOLID}
                    tagWidth={TagWidth.FIT_CONTENT}
                    text={t('product.freeProductCard.sopBenefit')}
                    theme={Theme.SUCCESS}
                  />
                </div>
              ) : (
                <span
                  className={styles['promotion-applied-icon-container']}
                  data-testid="promotion-applied-icon-container-test-id"
                >
                  <span className={styles['icon-container']} data-testid="icon-container-test-id">
                    <FAIcon theme={Theme.WHITE} iconName={'tags'} iconStyle={IconStyle.REGULAR} />
                  </span>
                </span>
              )}
            </>
          )}
          {showPromotionBenefitTag && (
            <CustomTag
              loaderType={LoaderType.WEBFONTS}
              isRelativeURL
              alt={t('product.TagsContainer.promotionBenefitTag')}
              src="/icons/gift-white.svg"
              width={14}
              height={14}
              text={promotionBenefitTagText}
            />
          )}
        </div>
        <Component
          productId={productId}
          brandName={brandName}
          productName={productName}
          link={link}
          alt={alt}
          productSize={productSize}
          derivedAvailabilityStatus={derivedAvailabilityStatus}
          firstAvailableFutureDate={firstAvailableFutureDate}
          dateSubText={dateSubText}
          productPrice={productPrice}
          currency={currency}
          productQuantity={productQuantity}
          cardType={CardType.FREEPRODUCT}
          strikethroughPrice={strikethroughPrice}
          onRemoveProduct={onRemoveProduct}
          showPropertiesCollection={showPropertiesCollection}
          showLinkForProductCard={showLinkForProductCard}
          pointValue={pointValue}
          businessVolume={businessVolume}
          prefixText={prefixText ? prefixText : t('product.common.item')}
          showProductId={true}
          showZeroAsFree={showZeroAsFree}
          wishListEle={
            <>
              {!showPropertiesCollection?.showCancelIcon && showHeartIcon && productData && (
                <span className={styles['heart-icon']} data-testid="heart-icon-test-id">
                  <AddToWishlistContainer
                    isPDP={false}
                    isPLPCard={false}
                    productData={productData}
                    isBundle={productData.isBundle}
                  />
                </span>
              )}
            </>
          }
        />

        {includesDerivedAvailabilityStockStatus(
          derivedAvailabilityStatus as DerivedAvailabilityStatusInternal,
          DerivedAvailabilityStatusComponentGroupKey.DISPOSITION_STATUSES,
        ) && (
          <div className={styles['dispostion-container']}>
            <DispositionStockStatus
              dispositionType={derivedAvailabilityStatus as DerivedAvailabilityStatusInternal}
              dispositionlabels={Dispositionlabels}
              dispositionValue={showDispositionHandler ? Dispositionlabels.CHANGE : Dispositionlabels.NONE}
              onDispositionLabelClick={onChangeClick}
            />
          </div>
        )}
      </div>
    );
  };
  return FreeCardComp;
};

export default FreeProductCard(ProductCardComponent);
export type { FreeProductCardPropsTypes };
